module.exports = __webpack_public_path__ + "static/media/8_opium_cake_small.9ff1547f.jpg";